import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectShellFragment } from '../../../../types/graphqlTypes';

type Project = ProjectShellFragment;

export function syncWmsLayers(viewer: RendererContextType['viewer'], project: Project | undefined, initializedPointclouds: string[], wmsLayers: Project['state']['wmsLayers']): void {
  if (!project?.state.wmsLayers || !viewer) return;
  if (!project.pointClouds.every((pointcloud) => initializedPointclouds.includes(pointcloud.id))) return;
  wmsLayers.forEach((layer) => {
    if (layer.visible) viewer.addWmsLayer(layer);
    else viewer.removeWmsLayer({ identifier: layer.identifier });
  });
}
